import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate, useParams, useNavigate } from 'react-router-dom';
import { FavouriteRunnersProvider } from './context/FavouriteRunnersContext';
import { Home } from './components/Home';
import { RunnerSelector } from './components/Runner';
import { ResultsPage } from './components/Races';
import { CustomLeaderboard, Progressions, Rankings } from './components/Records';
import { Parkrun } from './components/Parkrun';
import { H2H, Stats } from './components/Club';
import { SeriesSelector } from './components/Champs';
import { About } from './components/About';
import { SideMenu } from './components/SideMenu/SideMenu';
import SplashScreen  from './components/SplashScreen';
import { SafeArea } from 'capacitor-plugin-safe-area';
import { Filter } from './components/Filter';
import { dateAdd } from './components/Util';
import './App.css';

function RunnerSelectorRoute() {
  const { runnerId } = useParams();
  const navigate = useNavigate();

  return <RunnerSelector
              startRunnerID={runnerId ?? ""} 
              navigateTo={(path: string, replace?: boolean) => navigate(path, { replace: !!replace })}
          />;
}

function ResultsPageRoute() {
  const { raceId } = useParams();
  const navigate = useNavigate();

  return (
    <ResultsPage
      startRaceID={raceId ?? ""}
      navigateTo={(path: string, replace?: boolean) => navigate(path, { replace: !!replace })}
    />
  );
}

function App() {
  useEffect(() => {
    const applyInsets = async () => {
      try {
        const { insets } = await SafeArea.getSafeAreaInsets();
        const r = document.documentElement.style;
        r.setProperty('--inset-top', `${insets.top}px`);
        r.setProperty('--inset-bottom', `${insets.bottom}px`);
        r.setProperty('--inset-left', `${insets.left}px`);
        r.setProperty('--inset-right', `${insets.right}px`);
      } catch (e) {
        console.warn('SafeArea getSafeAreaInsets failed:', e);
      }
    };
    applyInsets();
    // Re-apply on viewport/orientation change
    const onResize = () => applyInsets();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  
  // Note: / should redirect to /splash (how to do it in version 6? https://reactrouter.com/en/main/upgrading/v5)
  return (
      <Router>
        <FavouriteRunnersProvider>
          <div className="safe-area">
          <SideMenu />
          <Routes>
            <Route path="/"             element={<SplashScreen />} />
            <Route path="/home"         element={<Home/>} />
            <Route path="/runners"      element={<RunnerSelectorRoute />} />
            <Route path="/runners/:runnerId" element={<RunnerSelectorRoute />} />
            <Route path="/races"        element={<ResultsPageRoute />} />
            <Route path="/races/:raceId" element={<ResultsPageRoute />} />
            <Route path="/leaderboard"  element={<Rankings />} />
            <Route path="/parkrun"      element={<Parkrun />} />
            <Route path="/about"        element={<About />} />
            <Route path="/headtohead"   element={<H2H />} />
            <Route path="/progressions" element={<Progressions />} />
            <Route path="/champs"       element={<SeriesSelector />} />
            <Route path="/stats"        element={<Stats />} />
            <Route path="/about"        element={<About />} />
            <Route path="/customleaderboard"
                element={<CustomLeaderboard start_filter={Filter.DateRangeFilter(dateAdd(new Date(), -14), new Date(), 'parkrun', '', '', false, '')}
                          start_open={true} title='Custom Leaderboard' />} />
            <Route path="/loading"      element={<SplashScreen />} />
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
          </div>
        </FavouriteRunnersProvider>
      </Router>
  );
}



export default App;
